export default __webpack_public_path__ + "static/media/04.62f1a65d.jpg";